import React from 'react';
import CategoryRow from './CategoryRow';

const StockTable = ({
  processedData,
  locationsBySelectedRegion,
  expandedRegions,
  toggleRegionExpansion,
  expandedProducts,
  toggleProductExpansion,
  toggleCategoryExpansion,
  findSKUStatus,
  tableData,
  pendingData,
  pendingDataUS,
  pendingDataUK,
  getLocationDisplayName,
}) => {
  const categories = [
  'CLASSIC',
  'LIGHT',
  'TRUNK',
  'SET',
  'BAG',
  'ACCESSORIES',
  'MISC',
]

  return (
    <div className="overflow-auto" style={{ height: 'calc(70vh)' }}>
      {Object.keys(processedData).length > 0 ? (
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead className="sticky top-0 bg-white z-10 border-b-2">
            <tr>
              <th className="px-3 py-3 text-left sticky left-0 bg-white border-r min-w-[200px] max-w-[250px]">
                Product/SKU
              </th>
              {Object.keys(locationsBySelectedRegion).map((region) => (
                <React.Fragment key={region}>
                  <th
                    className="px-3 py-3 text-center border-r min-w-[120px] cursor-pointer hover:bg-gray-100"
                    onClick={() => toggleRegionExpansion(region)}>
                    <div className="flex items-center justify-center gap-2">
                      <span className="font-bold">{region}</span>
                    </div>
                  </th>
                  {expandedRegions[region] && (
                    <>
                      <th className="px-3 py-3 text-center border-r min-w-[150px]">
                        Status
                      </th>
                      <th className="px-3 py-3 text-center border-r min-w-[120px]">
                        Next Container
                      </th>
                      <th className="px-3 py-3 text-center border-r min-w-[100px]">
                        Pending
                      </th>
                      {locationsBySelectedRegion[region].map((location) => (
                        <th
                          key={location}
                          className="px-3 py-3 text-center border-r min-w-[100px]">
                          {getLocationDisplayName ? getLocationDisplayName(location) : location}
                        </th>
                      ))}
                    </>
                  )}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => {
              const categoryProducts = processedData[category];
              if (!categoryProducts || categoryProducts.length === 0) return null;

              return (
                <CategoryRow
                  key={category}
                  category={category}
                  products={categoryProducts}
                  locationsBySelectedRegion={locationsBySelectedRegion}
                  expandedProducts={expandedProducts}
                  toggleProductExpansion={toggleProductExpansion}
                  toggleCategoryExpansion={toggleCategoryExpansion}
                  findSKUStatus={findSKUStatus}
                  tableData={tableData}
                  expandedRegions={expandedRegions}
                  pendingData={pendingData}
                  pendingDataUS={pendingDataUS}
                  pendingDataUK={pendingDataUK}
                  getLocationDisplayName={getLocationDisplayName}
                />
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="flex justify-center items-center h-32">
          <span>No data available</span>
        </div>
      )}
    </div>
  );
};

export default StockTable;
